'use client'
import { ChangePasswordAction } from '@/actions'
import { ButtonRoundStyle, RHFTextField } from '@/components'
import { Form } from '@/components/form/form-provider'
import yup from '@/utils/yup-global'
import { pwSchema } from '@/validations'
import { yupResolver } from '@hookform/resolvers/yup'
import { Grid } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useTransition } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

const ChangePassword = () => {
  const [isPending, startTransition] = useTransition()
  const t = useTranslations('UserProfile')
  const method = useForm<yup.InferType<typeof pwSchema>>({ resolver: yupResolver(pwSchema) })
  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = method
  const onSubmit = (values: yup.InferType<typeof pwSchema>) => {
    startTransition(() => {
      ChangePasswordAction(values).then((res) => {
        if (res?.status == 'error') return toast.error(res?.message)
        toast.success(res?.data)
        reset()
      })
    })
  }

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)} className="w-full" methods={method}>
        <Grid container spacing={2} columns={12} sx={{ width: '100%' }}>
          <Grid size={{ xs: 12 }}>
            <RHFTextField
              required
              type="password"
              name="oldPw"
              label={t('old-pw')}
              placeholder="Nhập mật khẩu ban đầu"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <RHFTextField
              required
              type="password"
              name="pw"
              label={t('Mật khẩu mới')}
              placeholder="Nhập mật khẩu mới"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <RHFTextField
              required
              type="password"
              name="pw1"
              label={t('cf-new-pw')}
              placeholder="Nhập lại mật khẩu mới"
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <ButtonRoundStyle
              type="submit"
              disabled={isPending}
              variant="contained"
              sx={{
                width: 'fit-content',
                minWidth: 120,
                textTransform: 'uppercase',
              }}
            >
              {isPending ? 'Loading' : t('change-pw')}
            </ButtonRoundStyle>
          </Grid>
        </Grid>
      </Form>
    </>
  )
}

export default ChangePassword
